const popupData = {
    po: [
        {
            layout: 'title',
            attributes: { title: 'Lesgeven in het primair onderwijs' },
        },
        {
            layout: 'text',
            attributes: {
                text:
                    '<p>In het basisonderwijs (ook wel primair onderwijs genoemd) werk je met kinderen in de leeftijd van vier tot en met ongeveer twaalf jaar. Als leerkracht basisonderwijs sta je voor een eigen groep, maar steeds vaker werken groepen en leerkrachten binnen een basisschool nauw met elkaar samen op leerpleinen of leerdomeinen. Je maakt afspraken met je collega’s in het schoolteam, hebt contacten met ouders en met instanties en je hebt een grote eigen verantwoordelijkheid.</p><p>&nbsp;</p><p>Leraren basisonderwijs zijn echte sociale dieren. Je wilt ‘je’ kinderen helpen in hun ontwikkeling en bent een spin in het web. Op een basisschool is iedere dag anders. En wil je je ontwikkelen in een bepaald vakgebied of bijvoorbeeld in bepaalde problemen van kinderen? Er wordt steeds meer aandacht besteed aan bij- en nascholingsprogramma’s. Zodat ook jij jezelf steeds kunt blijven ontwikkelen.</p>',
            },
        },
    ],
    vo: [
        {
            layout: 'title',
            attributes: { title: 'Lesgeven in het voortgezet onderwijs' },
        },
        {
            layout: 'text',
            attributes: {
                text:
                    '<p>Wil je deze doelgroep voorbereiden op een mooie toekomst? Jongeren coachen, begeleiden, ze kennis en vaardigheden bijbrengen, ze op een positieve manier vertrouwen voor de toekomst meegeven? Het vak van docent in het vo is de laatste jaren flink veranderd. De lesgevende docent wordt steeds meer een coach die de leerlingen begeleidt in hun ontwikkeling. Deze nieuwe manier van lesgeven vraagt ook nieuwe vaardigheden.</p><p>&nbsp;</p><p>Spreekt dit je aan? Dan is een lerarenopleiding voor jou misschien wel the place to be. Met een tweedegraads bevoegdheid mag je lesgeven in de onderbouw havo en vwo en onderbouw en bovenbouw van het vmbo. Maar je kunt er ook mee terecht in het speciaal onderwijs, waar kinderen nét wat meer aandacht nodig hebben. Of in het mbo en bij de volwasseneducatie. Wil je je verder verdiepen in je vak, dan kun je een eerstegraads bevoegdheid halen. Daarmee kun je ook terecht in de bovenbouw, en dus ook de examenklassen, van het voortgezet onderwijs.</p>',
            },
        },
    ],
    mbo: [
        {
            layout: 'title',
            attributes: {
                title: 'Lesgeven in het middelbaar beroeps onderwijs',
            },
        },
        {
            layout: 'text',
            attributes: {
                text:
                    '<p>Als leraar op het mbo begeleid je jongeren en jongvolwassenen op hun weg naar de arbeidsmarkt. Je leidt de vakmensen van de toekomst op. Dat kan als leraar in een algemeen vak zoals bijvoorbeeld Nederlands of Burgerschap, maar er zijn ook heel veel leraren uit het beroepenveld. Op het mbo kun je aan de slag met een eerste- of tweedegraads bevoegdheid. Op het mbo werk je samen met instructeurs en leraren. Samen met het bedrijfsleven uit de regio bereid je de studenten voor op een toekomst op de arbeidsmarkt.</p><p>&nbsp;</p><p>Op het mbo behalen docenten ook vaak een PDG (een Pedagogisch Didactisch Getuigschrift). Deze cursus is specifiek voor het mbo en biedt geen lesbevoegdheid zoals bij een lerarenopleiding. Je kunt dit duale traject (combinatie van werken en leren) alleen volgen als je al een aanstelling hebt op een mbo.</p>',
            },
        },
    ],
    hbo: [
        {
            layout: 'title',
            attributes: {
                title: 'Lesgeven in het hoger beroeps onderwijs',
            },
        },
        {
            layout: 'text',
            attributes: {
                text:
                    '<p>Je hebt geen onderwijsbevoegdheid nodig om te solliciteren als hbo-docent. Wel moet je bereid zijn om een Basiskwalificatie Didactische Bekwaamheid (BDB) te behalen. Je volgt hiervoor een opleiding van 6 tot 12 maanden in de eerste jaren van je contract. Je krijgt hiervoor tijd en geld van de hogeschool.</p><p>&nbsp;</p><p>Inhoudelijk is het een voorwaarde dat je vakmanschap meebrengt. Werkervaring in het vak of beroepsdomein waarin je onderwijs gaat verzorgen is een harde selectie-eis. Juist deze ervaring helpt je om actuele voorbeelden uit de praktijk in te brengen en hierover te discussiëren of brainstormen met je studenten. Ofwel: om continu de link te leggen tussen de opleiding en de beroepspraktijk.</p>',
            },
        },
    ],
    so: [
        {
            layout: 'title',
            attributes: {
                title: 'Lesgeven in het speciaal onderwijs',
            },
        },
        {
            layout: 'text',
            attributes: {
                text:
                    '<p>Het Nederlandse speciaal onderwijs (so) is ingedeeld in vier clusters waarin je kunt werken. Cluster 1 is bedoeld voor kinderen met een visuele beperking, cluster 2 zijn kinderen met een auditieve beperking of met een taal- spraakontwikkelingsstoornis, cluster 3 is voor kinderen met een lichamelijke beperking of langdurig ziekte, cluster 4 is voor kinderen met gedragsproblematiek.</p>',
            },
        },
    ],
    'full-switch': [
        {
            layout: 'title',
            attributes: {
                title: 'Een volledige overstap maken',
            },
        },
        {
            layout: 'text',
            attributes: {
                text: '<p></p>',
            },
        },
    ],
    hybrid: [
        {
            layout: 'title',
            attributes: {
                title: 'Hybride werken in het onderwijs',
            },
        },
        {
            layout: 'text',
            attributes: {
                text: '<p></p>',
            },
        },
    ],
    teacher: [
        {
            layout: 'title',
            attributes: {
                title: 'Leerkracht/docent',
            },
        },
        {
            layout: 'text',
            attributes: {
                text:
                    "<p>Als leerkracht/docent ben je verantwoordelijk voor het vakinhoudelijke, vakdidactische en pedagogische proces in jouw eigen groep en in de school. Je bereidt zelfstandig lessen voor en voert deze uit. Ook ben je verantwoordelijk voor het beoordelen van de onderwijsprestaties van leerlingen. Vaak worden de termen leerkracht, docent en leraar door elkaar gebruikt, maar er is wel een klein verschil. Zo wordt 'docent' meestal gebruikt voor iemand die lesgeeft op het voortgezet onderwijs, mbo, hbo of de universiteit. En ‘leerkracht’ wordt gebruikt voor wie lesgeeft in het basisonderwijs of speciaal onderwijs.</p>",
            },
        },
    ],
    assistant: [
        {
            layout: 'title',
            attributes: {
                title: 'Onderwijsassistent',
            },
        },
        {
            layout: 'text',
            attributes: {
                text:
                    '<p>De werkzaamheden van een klassenassistent, onderwijsassistent of leraarondersteuner verschillen per school en elk schoolbestuur mag zelf invulling geven aan het takenpakket. Er zitten verschillen in het takenpakket van onderwijsassistenten, klassenassistenten en leraarondersteuners, maar in de praktijk kunnen de taken ook overlappen. Het kan zijn dat een school alleen de term ‘onderwijsassistent’ gebruikt en het verschil niet maakt tussen deze drie functies. </p>',
            },
        },
    ],
    instructor: [
        {
            layout: 'title',
            attributes: {
                title: 'Instructeur/technisch onderwijsassistent (TOA)',
            },
        },
        {
            layout: 'text',
            attributes: {
                text:
                    '<p>Instructeurs zijn verantwoordelijk voor de praktijkonderdelen van de opleiding. Een instructeur geeft zelfstandig (delen van) lessen, maar altijd onder de verantwoordelijkheid van een docent of het onderwijsteam. Dat betekent niet dat er iemand uit het onderwijsteam ook daadwerkelijk aanwezig moet zijn in het (praktijk)lokaal of de werkplaats. Het is aan het team om de rolverdeling van de docent en de instructeur goed af te stemmen.</p>',
            },
        },
    ],
};

export default popupData;
